import { applyMiddleware, createStore } from 'redux';
import storage from 'redux-persist/lib/storage';
import { createFilter } from 'redux-persist-transform-filter';
import { persistReducer, persistStore } from 'redux-persist';
import { apiMiddleware } from 'redux-api-middleware';
import { routerMiddleware } from 'connected-react-router';
import immutableReducer from 'redux-immutable-state-invariant';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from './services/reducers';
import * as apiMiddlewares from './middlewares/apiMiddlewares';
import crashReporter from './middlewares/crashReporter';

export default ({ history, errorBroker, onRehydrationComplete }) => {
  const tokenFilter = createFilter('auth', ['token', 'authProvider']);
  const checkedInFilter = createFilter('user', ['checkedIn']);
  const reducer = persistReducer(
    {
      key: 'app',
      storage: storage,
      whitelist: ['auth', 'user'],
      transforms: [tokenFilter, checkedInFilter]
    },
    rootReducer(history)
  );

  let middlewares = [
    thunk,
    apiMiddlewares.apiCallModifier,
    apiMiddleware,
    apiMiddlewares.apiResponseMiddleware,
    routerMiddleware(history),

    crashReporter(errorBroker)
  ];
  if (process.env.NODE_ENV !== 'production') {
    middlewares = [...middlewares, immutableReducer()];
  }

  let devToolsOptions = {};
  if (process.env.NODE_ENV !== 'production') {
    devToolsOptions = {
      trace: true
    };
  }
  const composeEnhancers = composeWithDevTools(devToolsOptions);
  const store = createStore(
    reducer,
    composeEnhancers(applyMiddleware(...middlewares))
  );
  const persistor = persistStore(store, {}, () => onRehydrationComplete(store));
  return { store, persistor };
};
